import { Badge } from '@/components/ui/badge';
import { NetworkType, getNetworkDisplayName } from '@mls-wallet/shared-types';

interface NetworkBadgesProps {
  networks: NetworkType[];
  maxVisible?: number;
  className?: string;
}

export function NetworkBadges({
  networks,
  maxVisible = 3,
  className = '',
}: NetworkBadgesProps) {
  const visibleNetworks = networks.slice(0, maxVisible);
  const remainingCount = networks.length - maxVisible;

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {visibleNetworks.map((network) => (
        <Badge key={network} variant="secondary" className="text-xs">
          {getNetworkDisplayName(network)}
        </Badge>
      ))}
      {remainingCount > 0 && (
        <Badge variant="secondary" className="text-xs text-muted-foreground">
          +{remainingCount}
        </Badge>
      )}
    </div>
  );
}
